import type { AppContext, ViewCleanup } from "../app";
import { loadCountries, groupByRegion } from "../data/countries";

export const mountRegionCleared = async (
  root: HTMLElement,
  ctx: AppContext,
): Promise<ViewCleanup> => {
  const region = root.dataset.region ?? "this region";
  root.classList.add("view-region-cleared");

  ctx.globe.setTargetIso(null);
  ctx.globe.setHoverEnabled(true);

  const card = document.createElement("section");
  card.className = "celebrate-card";
  root.appendChild(card);

  const table = await loadCountries();
  const grouped = groupByRegion(table);
  const count = grouped[region]?.length ?? 0;

  card.innerHTML = `
    <p class="celebrate-eyebrow">Region cleared</p>
    <h1>${region}</h1>
    <p class="celebrate-subtitle">
      You've answered every one of the ${count} countries in this region at
      least once. Mixed mode is unlocked.
    </p>
    <div class="celebrate-actions">
      <button type="button" class="celebrate-again">Practice it again</button>
      <button type="button" class="celebrate-back">Pick another region</button>
    </div>
  `;

  const again = card.querySelector(".celebrate-again") as HTMLButtonElement;
  const back = card.querySelector(".celebrate-back") as HTMLButtonElement;

  const onAgain = (): void => ctx.nav.goLearn({ region });
  const onBack = (): void => ctx.nav.goRegionPicker();
  again.addEventListener("click", onAgain);
  back.addEventListener("click", onBack);

  return () => {
    again.removeEventListener("click", onAgain);
    back.removeEventListener("click", onBack);
    root.classList.remove("view-region-cleared");
  };
};
